<style lang="scss"></style>
<style lang="scss" scoped="scoped">
.container {
  background: #03006c;
}
.yongxinBigTitle {
  background-image: url(../../../../../../../assets/img/web/yongxin/big_title_bg.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.biankuang {
  border: 4px solid rgba(108, 167, 255, 1);
  border-radius: 5px;
  box-shadow: 0px 0px 30px 0px rgba(45, 53, 255, 1) inset;
  box-shadow: 0px 0px 80px 0px rgba(45, 53, 255, 1) inset;
}

.yongxinSmallTitle {
  background-image: url(../../../../../../../assets/img/web/yongxin/small_title_bg_4.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
</style>

<template>
  <div class="container" ref="contianer" style="position: absolute;height: 100%;width: 100%;box-sizing: border-box;display: flex;flex-direction: column;">
    <div ref="header" class="yongxinBigTitle" style="height:66px;width:100%;display: flex;justify-content: center;align-items: center;color: white;font-weight: bold;font-size: 30px;">
      <p>公用工程综合看板</p>
    </div>

    <div style="width: 100%;box-sizing: border-box;display: grid; grid-template-columns: 1fr 1fr 1fr;grid-template-rows: 1fr 1fr ;grid-gap: 10px;flex:1;padding: 20px;">
      <div class="biankuang" v-for="i in [0, 1, 2, 3, 4, 5]" style="background: #03006c;display: flex;flex-direction: column;height: 100%;">
        <div ref="titleBar" class="titleBar" style="display: flex;justify-content: space-between;align-items:center ;padding-bottom: 10px;">
          <div class="yongxinSmallTitle" style="width: 100%;height: 40px;color:white;display:flex;justify-content:center;align-items:center;font-size:20px">
            {{ $t(['冷却水出水温度', '冷却水流量', '冷却水出水压力', '冷却水回水温度', '空压机流量', '空压机压力'][i]) }}
          </div>
        </div>

        <div style="display: flex;justify-content: space-around;align-items: center;flex: 1;margin-bottom: 20px;">
          <div style="display: flex;flex-direction: column;justify-content: center;align-items: center;width: 100%;position: relative;">
            <img v-if="i == 0 || i == 3" style="width: 60%;height: auto;" src="../../../../../../../assets/img/web/yongxin/出水温度.png" />
            <img v-if="i == 1" style="width: 50%;height: auto;" src="../../../../../../../assets/img/web/yongxin/冷却水流量.png" />
            <img v-if="i == 4" style="width: 50%;height: auto;" src="../../../../../../../assets/img/web/yongxin/空压机流量.png" />
            <img v-if="i == 2 || i == 5" style="width: 60%;height: auto;" src="../../../../../../../assets/img/web/yongxin/出水压力.png" />

            <div :style="{ 'margin-top': i == 1 || i == 4 ? '-10%' : '10%' }" style="position: absolute;margin-top: 10%;display: flex;flex-direction: column;align-items: center;">
              <p style="color:white;font-weight:bold;font-size: 46px;">{{ ([dts.chushuiwendu, dts.lengqueshuiliuliang, dts.chushuiyali, dts.huishuiwendu, dts.kongqijiliuliang, dts.kongshuijiyali][i] != null ? [dts.chushuiwendu, dts.lengqueshuiliuliang, dts.chushuiyali, dts.huishuiwendu, dts.kongqijiliuliang, dts.kongshuijiyali][i] : '-') + ['℃', 'm³/h', 'mpa', '℃', 'm³/h', 'mpa'][i] }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'web_customize_yongxin_monitor_mes_lengshuiji_index',
  components: {},
  watch: {
    '$attrs.orgId'(newValue, oldValue) {
      if (this.utils.isEqual(newValue, oldValue)) {
        return;
      }
      this.listData();
    }
  },
  data() {
    return {
      timer: null,
      dts: {}
    };
  },
  created() {
    this.timer = setInterval(() => {
      this.listData();
    }, 120000);
    this.listData();
  },
  mounted() {
    console.log('$attrs', this.$attrs);
    this.resize();
    this.utils.event_hub.$on('RESIZE', () => {
      this.resize();
    });
  },
  destroyed() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    async listData() {
      let response = await this.http.get('/custom/yongxin/report/publicWorks/list', {});
      this.dts = response.data;
    },
    resize() {
      //因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
      setTimeout(() => {}, 800);
    }
  }
};
</script>
